import {useTrans} from '@common/i18n/use-trans';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {useMutation} from '@tanstack/react-query';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {apiClient, queryClient} from '@common/http/query-client';
import {DatatableDataQueryKey} from '@common/datatable/requests/paginated-resources';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {UseFormReturn} from 'react-hook-form';
import { Prompt } from '@app_modules/chats/prompt';
import { useParams } from 'react-router-dom';
import { BackendResponse } from '@common/http/backend-response/backend-response';


interface Response extends BackendResponse {
  prompt: Prompt;
}

export interface DemoChatPayload extends Prompt {
 id: number|string;
}

const Endpoint = () => `demo-chat`;

export function useDemoChat(form: UseFormReturn<DemoChatPayload>) {
  return useMutation({
    mutationFn: (payload: DemoChatPayload) => updateChat(payload),
    onSuccess: response => {
      
      // toast(trans(message('Chat updated')));
      // queryClient.invalidateQueries({
      //   queryKey: [Endpoint(response. chat.id)],
      // });
      // queryClient.invalidateQueries({
      //   queryKey: DatatableDataQueryKey('chats'),
      // });
    },
    onError: err => onFormQueryError(err, form),
  });
}

function updateChat({
  id,
  ...payload
}: DemoChatPayload): Promise<Response> {
  const backendPayload = {
    ...payload
  };
  return apiClient.post(Endpoint(), backendPayload).then(r => r.data);
}
